import { Injectable } from '@angular/core';
import moment from 'moment';
import { DateClassMatch, ServiceintervalChartItem } from '../components/aftale/models';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class GraphService {
  constructor(private datepipe: DatePipe) {}

  getRange(startDate: Date, endDate: Date, matches: DateClassMatch[]): ServiceintervalChartItem[] {
    const fromDate = moment(startDate).startOf('month');
    const toDate = moment(endDate).endOf('month');
    const diff = toDate.diff(fromDate, 'months', true);
    const range = [];
    for (let i = 0; i < diff; i++) {
      const classes = [];
      const comments = [];

      const month = moment(fromDate).add(i, 'month');

      const monthStartDate = month.startOf('month').toDate();
      const monthEndDate = month.endOf('month').toDate();

      const adjustedMonthStartDate = startDate > monthStartDate ? startDate : monthStartDate;
      const adjustedMonthEndDate = endDate < monthEndDate ? endDate : monthEndDate;

      matches.forEach((match) => {
        if (match.date && new Date(match.date) >= adjustedMonthStartDate && new Date(match.date) <= adjustedMonthEndDate) {
          classes.push(match.class);

          const comment = match.comment + ': ' + this.datepipe.transform(match.date, 'dd.MM.yyyy');
          comments.push(comment);
        }
      });

      if (month.startOf('month').isSameOrAfter(new Date())) {
        classes.push('period__future');
      }

      range.push({
        startDate: adjustedMonthStartDate,
        endDate: adjustedMonthEndDate,
        classes: classes,
        comments: comments,
      });
    }
    return range;
  }
}
